$(function () {

	$('.datepicker').not('.month').datepicker({
		format:'dd/mm/yyyy',
		todayHighlight:true,
		autoclose:true,
	});

	$('.datepicker.month').datepicker({
		format:'yyyy/mm',
		startView: 'months', 
		minViewMode: 'months',
	});

});